import { FamilyApplicationQueries } from '@/queries/family_applications/queries.ts'
import { useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'

import { StateQueries } from '@/queries/states/queries.ts'
import { selectSelectedProgram } from '@/storage/programs/slice.ts'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { USA_COUNTRY_CODE } from '../../providers/components/SchoolForm/constants/constants.ts'
import ApplicationDetailsView from './ApplicantDetailsView.tsx'

export default function ApplicantDetailsWrapper() {
  const { applicantId } = useParams<{ applicantId?: string }>()
  const programId = useSelector(selectSelectedProgram).id

  const { data, status, error } = useQuery(
    FamilyApplicationQueries.getFamilyApplicationById(applicantId!, programId, {
      staleTime: 0,
      refetchOnMount: true,
    })
  )

  const StateData = useQuery(
    StateQueries.getStateByCountry(USA_COUNTRY_CODE, {
      staleTime: Infinity,
    })
  )

  const {
    data: awardDetails,
    status: statusAwardDetails,
    error: errorAwardDetails,
  } = useQuery(
    FamilyApplicationQueries.getAwardDetailsByScholarshipApplicationId(
      applicantId!,
      programId
    )
  )

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  if (
    status === 'error' ||
    statusAwardDetails === 'error' ||
    StateData.status === 'error'
  ) {
    return (
      <div>
        {error?.message && <div>{error.message}</div>}
        {errorAwardDetails?.message && <div>{errorAwardDetails.message}</div>}
      </div>
    )
  }

  if (
    status === 'pending' ||
    statusAwardDetails === 'pending' ||
    StateData.status === 'pending'
  ) {
    return <div>Loading</div>
  }

  return (
    <ApplicationDetailsView
      ApplicantData={data}
      awardDetails={awardDetails}
      states={StateData.data}
    />
  )
}
